import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_CONTENTFUL_VIDEO,
    FETCH_CONTENTFUL_VIDEO_SUCCESS,
    FETCH_CONTENTFUL_VIDEO_FAILED,
    FETCHING_CONTENTFUL_VIDEO
} from '../actions/ActionTypes';

// worker
export function* fetchContentfulVideoItem(action) {
    try {
        const { contentID, locale } = action.payload;

        yield put({
            type: FETCHING_CONTENTFUL_VIDEO
        });

        const response = yield call(
            axios.post,
            '/gateway/graph-atp/graphql',
            {
                query: `{Videos(videoKey:"${contentID}", locale:"${locale}"){fields{videoUrl,videoTitle,videoThumbnailUrl,subtitleUrl}}}`
            },
            { baseURL: '/' }
        );

        if (response.data.errors) {
            yield put({
                type: FETCH_CONTENTFUL_VIDEO_FAILED,
                error: response.data.errors[0].message,
                action: action.payload
            });
        } else {
            yield put({
                type: FETCH_CONTENTFUL_VIDEO_SUCCESS,
                atpContentFulVideoItem: response.data.data.Videos,
                action: action.payload
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_CONTENTFUL_VIDEO_FAILED,
            error: e,
            action: action.payload
        });
    }
}

// watcher
export const loadContentFulVideo = [takeEvery(FETCH_CONTENTFUL_VIDEO, fetchContentfulVideoItem)];
